export default __webpack_public_path__ + "media/images/logo/contest/jta-1200bf69161a1a1382a7c23307f94821.jpg";